import { render, staticRenderFns } from "./ModuleIndex.vue?vue&type=template&id=35cb9832&"
import script from "./ModuleIndex.vue?vue&type=script&lang=ts&"
export * from "./ModuleIndex.vue?vue&type=script&lang=ts&"
import style0 from "./ModuleIndex.vue?vue&type=style&index=0&id=35cb9832&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports